import { render, staticRenderFns } from "./SelectIdeaHeader.vue?vue&type=template&id=482a1d50"
import script from "./SelectIdeaHeader.vue?vue&type=script&lang=js"
export * from "./SelectIdeaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports